module.exports = __webpack_public_path__ + "img/Sutures.e44bd69e.png";